import {
  FETCH_ASSESSMENT_SUMMARY_START,
  FETCH_ASSESSMENT_SUMMARY_SUCCESS,
  FETCH_ASSESSMENT_SUMMARY_FAILED,
  UPDATE_QUIZ_DESCRIPTION_SUCCESS,
  UPDATE_QUIZ_DESCRIPTION_FAILED,
} from 'chameleon-src/actionTypes';

import getAssessmentSummary from 'chameleon-src/utility/helpers/getAssessmentSummary';
import updateQuizDescription from 'chameleon-src/utility/helpers/updateQuizDescription';
import { toast } from 'chameleon/ui-stack/ui/toast';

export const fetchAssessmentSummary =
  (client, itemId, groupId) => async (dispatch) => {
    dispatch({
      type: FETCH_ASSESSMENT_SUMMARY_START,
    });
    try {
      const response = await getAssessmentSummary(client, itemId, groupId);
      dispatch({
        type: FETCH_ASSESSMENT_SUMMARY_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: FETCH_ASSESSMENT_SUMMARY_FAILED,
        payload: { errorMessage: error.message },
      });
    }
  };

export const updateQuizDescriptionAction =
  (client, variables, closeEdit) => async (dispatch) => {
    try {
      const response = await updateQuizDescription(client, variables);
      if (response) {
        dispatch({
          type: UPDATE_QUIZ_DESCRIPTION_SUCCESS,
          payload: { description: variables.description },
        });
        closeEdit();
      }
    } catch (error) {
      dispatch({
        type: UPDATE_QUIZ_DESCRIPTION_FAILED,
        payload: { errorMessage: error.message },
      });
      toast('Update quiz description failed. Please try again later', {
        timeout: 5,
      });
      closeEdit(error);
    }
  };
